import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CanDeleteBoardEnterpriseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CanDeleteBoardEnterprise"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"},{"kind":"EnumValue","value":"MemberBoards"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idAdmins"}},{"kind":"Field","name":{"kind":"Name","value":"isRealEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPrefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boardDeleteRestrict"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"private"}},{"kind":"Field","name":{"kind":"Name","value":"org"}},{"kind":"Field","name":{"kind":"Name","value":"enterprise"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CanDeleteBoardEnterprise","document":CanDeleteBoardEnterpriseDocument}} as const;
export type CanDeleteBoardEnterpriseQueryVariables = Types.Exact<{
  entId: Types.Scalars['ID'];
}>;


export type CanDeleteBoardEnterpriseQuery = (
  { __typename: 'Query' }
  & { enterprise?: Types.Maybe<(
    { __typename: 'Enterprise' }
    & Pick<Types.Enterprise, 'idAdmins' | 'isRealEnterprise'>
    & { organizationPrefs: (
      { __typename: 'Organization_Prefs' }
      & { boardDeleteRestrict?: Types.Maybe<(
        { __typename: 'Organization_Prefs_BoardDeleteRestrict' }
        & Pick<Types.Organization_Prefs_BoardDeleteRestrict, 'private' | 'org' | 'enterprise' | 'public'>
      )> }
    ) }
  )> }
);




/**
 * __useCanDeleteBoardEnterpriseQuery__
 *
 * To run a query within a React component, call `useCanDeleteBoardEnterpriseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanDeleteBoardEnterpriseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanDeleteBoardEnterpriseQuery({
 *   variables: {
 *      entId: // value for 'entId'
 *   },
 * });
 */
export function useCanDeleteBoardEnterpriseQuery(baseOptions: Apollo.QueryHookOptions<CanDeleteBoardEnterpriseQuery, CanDeleteBoardEnterpriseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanDeleteBoardEnterpriseQuery, CanDeleteBoardEnterpriseQueryVariables>(CanDeleteBoardEnterpriseDocument, options);
      }
export function useCanDeleteBoardEnterpriseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanDeleteBoardEnterpriseQuery, CanDeleteBoardEnterpriseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanDeleteBoardEnterpriseQuery, CanDeleteBoardEnterpriseQueryVariables>(CanDeleteBoardEnterpriseDocument, options);
        }
export type CanDeleteBoardEnterpriseQueryHookResult = ReturnType<typeof useCanDeleteBoardEnterpriseQuery>;
export type CanDeleteBoardEnterpriseLazyQueryHookResult = ReturnType<typeof useCanDeleteBoardEnterpriseLazyQuery>;
export type CanDeleteBoardEnterpriseQueryResult = Apollo.QueryResult<CanDeleteBoardEnterpriseQuery, CanDeleteBoardEnterpriseQueryVariables>;